import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

const heroImage =
  'https://readdy.ai/api/search-image?query=A%20bright%20editorial%20flat%20lay%20of%20assorted%20fashion%20products%20in%20soft%20pastel%20tones%2C%20white%20sneakers%2C%20a%20folded%20sage%20green%20hoodie%2C%20a%20tan%20leather%20bag%2C%20round%20sunglasses%20and%20a%20cap%20arranged%20on%20a%20warm%20cream%20surface%20with%20gentle%20natural%20window%20light%2C%20fresh%20minimal%20aesthetic%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=acb-hero-01&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const results = query.trim()
    ? categories
        .filter((c) => t(`cat.${c.key}`).toLowerCase().includes(query.trim().toLowerCase()))
        .slice(0, 5)
    : [];

  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img src={heroImage} alt="AllChinaBuy spreadsheet product finds" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 text-xs font-semibold text-foreground-900 backdrop-blur">
          <i className="ri-sparkling-line text-primary-600 w-4 h-4 flex items-center justify-center" />
          {t('hero.badge')}
        </span>

        <h1 className="mx-auto mt-6 max-w-4xl font-heading text-3xl md:text-5xl font-bold leading-tight text-background-50">
          {t('hero.title')}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm md:text-base text-background-100/90 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero.ctaPrimary')}
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero.ctaSecondary')}
            <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>

        <div className="relative mx-auto mt-8 max-w-xl">
          <div className="flex items-center rounded-full bg-background-50 shadow-sm pl-5 pr-2 py-2">
            <i className="ri-search-line text-foreground-400 w-5 h-5 flex items-center justify-center" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t('hero.searchPlaceholder')}
              className="flex-1 bg-transparent px-3 py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="button"
              onClick={() => setQuery('')}
              className="rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('common.explore')}
            </button>
          </div>

          {results.length > 0 && (
            <div className="absolute left-0 right-0 top-full mt-2 overflow-hidden rounded-xl border border-background-200 bg-background-50 text-left shadow-sm z-20">
              {results.map((c) => (
                <a
                  key={c.key}
                  href={c.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 px-4 py-3 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <img src={c.image} alt={t(`cat.${c.key}`)} className="h-10 w-10 rounded-md object-cover object-top" />
                  <span className="text-sm font-medium text-foreground-900">{t(`cat.${c.key}`)}</span>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}